var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedalStar = function SvgMedalStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA853",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.667 14.999c0 2.416-.717 4.633-1.95 6.483-1.8 2.667-4.65 4.55-7.967 5.033q-.85.15-1.75.15t-1.75-.15c-3.316-.483-6.166-2.366-7.966-5.033A11.6 11.6 0 0 1 8.334 15C8.334 8.549 13.55 3.332 20 3.332s11.667 5.217 11.667 11.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA853",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m35.417 30.783-2.75.65c-.617.15-1.1.617-1.234 1.234l-.583 2.45c-.317 1.333-2.017 1.733-2.9.683L20 26.667l-7.95 9.15c-.884 1.05-2.584.65-2.9-.684l-.584-2.45a1.66 1.66 0 0 0-1.233-1.233l-2.75-.65c-1.267-.3-1.717-1.883-.8-2.8l6.5-6.5c1.8 2.667 4.65 4.55 7.967 5.033q.85.15 1.75.15t1.75-.15c3.317-.483 6.166-2.366 7.967-5.033l6.5 6.5c.916.9.466 2.483-.8 2.783M20.967 9.968l.983 1.967c.134.266.483.533.8.583l1.784.3c1.133.183 1.4 1.017.583 1.833l-1.384 1.384c-.233.233-.366.683-.283 1.016l.4 1.717c.317 1.35-.4 1.883-1.6 1.167l-1.666-.984c-.3-.183-.8-.183-1.1 0l-1.667.984c-1.2.7-1.917.183-1.6-1.167l.4-1.717c.066-.316-.05-.783-.284-1.016L14.95 14.65c-.816-.816-.55-1.633.584-1.833l1.783-.3c.3-.05.65-.317.783-.583l.983-1.967c.484-1.067 1.35-1.067 1.884 0"
  })));
};
export default SvgMedalStar;